import { useState } from 'react';
import { DatePicker } from 'antd';
import ArrowBackDatePickerIcon from 'components/icons/ArrowBackDatePickerIcon';
import NextArrowDatePickerIcon from 'components/icons/NextArrowDatePickerIcon';
import 'moment/locale/es';
import NextArrowIcon from 'components/icons/NextArrowIcon';
import es from 'antd/es/date-picker/locale/es_ES';
import Colors from 'assets/Colors';
import moment from 'moment';
import s from './styles';

function generateDateRange(date, period) {
  return {
    start: moment(date).startOf(period),
    end: moment(date).endOf(period),
  };
}

function CustomDatePickerSelect({ value, onChange }) {
  const [periodType] = useState('date');
  let format = 'D MMM YYYY';
  if (periodType === 'month') {
    format = 'MMM YYYY';
  } else if (periodType === 'year') {
    format = 'YYYY';
  }

  return (
    <s.Wrapper>
      <s.WrapperBottomComponents>
        <s.WrapperDatePicker>
          <s.IconArrowWrapper
            style={{ borderRight: `0.5px solid ${Colors.text_secondary}` }}
            onClick={() => {
              const date = moment(value).add(
                -1,
                `${periodType === 'date' ? 'days' : `${periodType}s`}`
              );
              onChange(
                date,
                periodType,
                generateDateRange(
                  date,
                  periodType === 'date' ? 'day' : `${periodType}`
                )
              );
            }}
          >
            <NextArrowIcon style={{ transform: 'rotate(180deg)' }} />
          </s.IconArrowWrapper>
          <div style={{ flex: 1 }} />
          <DatePicker
            value={value}
            format={format}
            inputReadOnly
            style={{
              width: '100%',

              position: 'absolute',
              paddingLeft: '32px',
              paddingRight: '32px',
              height: '40px',
            }}
            allowClear={false}
            onChange={(val) => {
              const date = moment(val);
              onChange(
                date,
                periodType,
                generateDateRange(
                  date,
                  periodType === 'date' ? 'day' : `${periodType}`
                )
              );
            }}
            bordered={false}
            locale={es}
            nextIcon={
              periodType === 'date' || periodType === 'week' ? (
                <NextArrowDatePickerIcon style={{ margin: '0px 9px' }} />
              ) : (
                ''
              )
            }
            prevIcon={
              periodType === 'date' || periodType === 'week' ? (
                <ArrowBackDatePickerIcon style={{ margin: '0px 9px' }} />
              ) : (
                ''
              )
            }
            superNextIcon={
              periodType === 'month' || periodType === 'year' ? (
                <NextArrowDatePickerIcon style={{ margin: '0px 9px' }} />
              ) : (
                ''
              )
            }
            superPrevIcon={
              periodType === 'month' || periodType === 'year' ? (
                <ArrowBackDatePickerIcon style={{ margin: '0px 9px' }} />
              ) : (
                ''
              )
            }
            suffixIcon=""
            picker={periodType}
          />
          <s.IconArrowWrapper
            style={{ borderLeft: `0.5px solid ${Colors.text_secondary}` }}
            onClick={() => {
              const date = moment(value).add(
                +1,
                `${periodType === 'date' ? 'days' : `${periodType}s`}`
              );
              onChange(
                date,
                periodType,
                generateDateRange(
                  date,
                  periodType === 'date' ? 'day' : `${periodType}`
                )
              );
            }}
          >
            <NextArrowIcon />
          </s.IconArrowWrapper>
        </s.WrapperDatePicker>
      </s.WrapperBottomComponents>
    </s.Wrapper>
  );
}

export default CustomDatePickerSelect;
